import styled from "styled-components"

import { SPACING } from "ggx-componentlibrary/design/spacing/spacing.constants"
import { Body } from "ggx-componentlibrary/design/typography/typography.styles"

const DriverNotesContainer = styled.div`
  margin-bottom: ${SPACING.L};
  &:last-child {
    margin-bottom: 0;
  }
`

const StyledNote = styled(Body)`
  word-wrap: break-word;
`

export { DriverNotesContainer, StyledNote }
